import React, { useEffect, useState } from "react";
import AdminLayout from "../../layout/AdminLayout";
import { errorMsg, success } from "../../../utils/notifications";
import { getOwnerProfile } from "../../../api/owners.api";
import { useParams } from "react-router-dom";
import {
  getPositionLogs,
  getScreenById,
  getMonthlyScreenCount,
} from "../../../api/screens.api";
import { API } from "../../../api/api";
import PaymentDetailsModel from "../../payments/PaymentDetailsModel";
import { createPayment } from "../../../api/payments.api";
import CampaignDetailsModal from "../Campaigns/CampaignDetailsModel";
import AddScreen from "./AddScreen";
import { FiPlus } from "react-icons/fi";
const initialData = {
  status: "",
  model: "",
  vehicle: "",
};
function ScreenDetails() {
  let lastDate = "";
  const { id } = useParams();
  const [screenDetails, setScreenDetails] = useState(null);
  const [positionLogs, setPositionLogs] = useState([]);
  const [monthlyScreenCount, setMonthlyScreenCount] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addScreenOpen, setAddScreenOpen] = useState(false);
  const [editScreenData, setEditScreenData] = useState(null);

  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [paymentData, setPaymentData] = useState({
    ownerId: "",
    ownerName: "",
    month: "",
    totalDays: "",
    amountPerDay: "",
    screenId: "",
  });
  console.log("Payment Data", paymentData);
  const [paidStatus, setPaidStatus] = useState({}); // Store payment status per month

  // Fetch screen details
  useEffect(() => {
    getScreenById(id)
      .then((res) => {
        setScreenDetails(res?.data?.screen);
        console.log("Screen Details", res.data?.screen);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [id]);

  // Fetch position logs
  useEffect(() => {
    getPositionLogs(id)
      .then((res) => {
        const sortedLogs = res?.data?.sort(
          (a, b) => new Date(b.start) - new Date(a.start)
        );
        setPositionLogs(sortedLogs);
      })
      .catch((error) => {
        console.error("Error fetching position logs", error);
      });
  }, [id]);
  const closeCampaignModal = () => {
    setIsCampaignModalOpen(false);
    setSelectedMonth(null);
  };
  // Fetch monthly screen count and check payment status
  useEffect(() => {
    getMonthlyScreenCount(id)
      .then((res) => {
        setMonthlyScreenCount(res.data.monthlyScreenCount);
        checkPaymentStatus(res.data.monthlyScreenCount); // Call after fetching the screen count
      })
      .catch((error) => {
        console.error("Error fetching monthly screen count", error);
      });
  }, [id, screenDetails]);

  // Check if the payment has been made for each month
  const checkPaymentStatus = async (monthlyScreenCount) => {
    const ownerId = screenDetails?.vehicle?.owner;
    if (!ownerId) return;

    const statusMap = {};
    for (const monthData of monthlyScreenCount) {
      try {
        const paymentStatusRes = await API.post(`/payment/status`, {
          screenId: screenDetails?._id, // Use screenId from paymentData
          ownerId: ownerId,
          month: monthData.month, // Pass the month dynamically
        });
        console.log("PAYEMNT STATSUS", paymentStatusRes);
        statusMap[monthData.month] = paymentStatusRes.data.isPaid; // Store per month status
      } catch (error) {
        console.error(
          `Error checking payment status for ${monthData.month}`,
          error
        );
      }
    }
    setPaidStatus(statusMap); // Update the payment status
  };

  // Handle pay button click
  const handlePayClick = async (month) => {
    const ownerId = screenDetails?.vehicle?.owner;
    const screenId = screenDetails?._id;
    try {
      const ownerResponse = await getOwnerProfile(ownerId);
      const ownerName = ownerResponse.data.owner?.name;

      // Directly set the screenId here to ensure it is included in payment data
      setPaymentData((prev) => ({
        ...prev,
        ownerId,
        screenId, // Ensure screenId is fetched from screenDetails
        ownerName,
        month: month.month,
        totalDays: month.days,
      }));
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching owner details", error);
    }
  };

  // Handle payment submission
  const handlePaymentSubmit = async (paymentData) => {
    console.log("Creating payment time the data is : ", paymentData); // Log payment data to check if screenId is included
    try {
      await createPayment(paymentData);
      checkPaymentStatus(monthlyScreenCount); // Call after fetching the screen count
      success("Payment submitted successfully! \n Check your email please.");
    } catch (error) {
      console.error("Error creating payment: ", error); // Log the error for debugging
      errorMsg("Failed to submit payment. Please try again.");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };
  const handleDownloadInvoice = async (month) => {
    try {
      const response = await API.get(`/payment/download`, {
        params: {
          screenId: screenDetails?._id,
          month,
        },
      });

      const { pdfLink } = response.data;
      console.log("PDF Link:", pdfLink); // Log the PDF link

      if (pdfLink) {
        // Directly open the PDF link in a new tab
        window.open(pdfLink, "_blank");
      } else {
        throw new Error("No PDF link found");
      }
    } catch (error) {
      console.error("Error downloading the invoice", error);
      errorMsg("Failed to download invoice. Please try again.");
    }
  };

  return (
    <AdminLayout title="Screen Details">
      <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevent navigation
            setAddScreenOpen(true);
            setEditScreenData(screenDetails);
          }}
          className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
        >
          {" "}
          <FiPlus className="text-lg text-gray-700" />
          Edit Screen
        </button>
      </div>
      <AddScreen
        open={addScreenOpen}
        setOpen={setAddScreenOpen}
        initialData={initialData}
        screenData={editScreenData}
      />
      <div className="my-5 grid grid-cols-1 sm:grid-cols-12 gap-6 lg:grid-cols-12 md:grid-cols-12">
        <div className="col-span-12 xl:col-span-6 lg:col-span-6">
          <div className="bg-white rounded-md p-5">
            <div className="bg-gray-100 rounded-md">
              <div className="p-5">
                <div>
                  <div className="flex justify-between my-2">
                    <h1 className="text-gray-600 font-semibold text-base">
                      Screen Model
                    </h1>
                    <span className="text-gray-400 font-medium text-base">
                      {screenDetails?.model}
                    </span>
                  </div>
                  <div className="flex justify-between my-2">
                    <h1 className="text-gray-600 font-semibold text-base">
                      Screen Orientaion
                    </h1>
                    <span className="text-gray-400 font-medium text-base">
                      {screenDetails?.defaultOrientation}
                    </span>
                  </div>
                  <div className="flex justify-between my-2">
                    <h1 className="text-gray-600 font-semibold text-base">
                      Screen Status
                    </h1>
                    <span
                      className={`px-2 py-0.5 rounded ${
                        screenDetails?.status === "Active"
                          ? "bg-green-100 text-green-700"
                          : screenDetails?.status === "In Active"
                          ? "bg-orange-100 text-orange-700"
                          : screenDetails?.status === "Under Maintenance"
                          ? "bg-yellow-100 text-yellow-600"
                          : screenDetails?.status === "Retired"
                          ? "bg-red-100 text-red-700"
                          : "bg-gray-100 text-gray-800"
                      } text-sm`}
                    >
                      {screenDetails?.status}
                    </span>
                  </div>
                  <div className="flex justify-between my-2">
                    <h1 className="text-gray-600 font-semibold text-base">
                      Display Status
                    </h1>
                    <span
                      className={`px-2 py-0.5 rounded ${
                        screenDetails?.onlineStatus === "offline"
                          ? "bg-red-600 text-white"
                          : screenDetails?.onlineStatus === "online"
                          ? "bg-green-500 text-white"
                          : screenDetails?.status === "Retired"
                          ? "bg-red-100 text-red-700"
                          : "bg-gray-100 text-gray-800"
                      } text-sm`}
                    >
                      {screenDetails?.onlineStatus}
                    </span>
                  </div>
                </div>

                {/* Conditional Rendering of Information Based on Screen Type */}
                {screenDetails?.screenType === "vehicle" ? (
                  <>
                    <div className="my-2">
                      <h1 className="text-gray-600 font-semibold text-base">
                        Vehicle Information
                      </h1>
                    </div>
                    <div className="ml-5 w-80">
                      {[
                        {
                          label: "Brand",
                          value: screenDetails?.vehicle?.brand,
                        },
                        {
                          label: "Model",
                          value: screenDetails?.vehicle?.model,
                        },
                        { label: "Type", value: screenDetails?.vehicle?.type },
                        {
                          label: "Location",
                          value: screenDetails?.vehicle?.location,
                        },
                      ].map((item, i) => (
                        <div key={i} className="my-1 grid grid-cols-12">
                          <div className="col-span-6">
                            <h1 className="text-gray-600 font-semibold text-base">
                              {item.label}
                            </h1>
                          </div>
                          <div className="col-span-6">
                            <h1 className="text-gray-400 font-medium text-base">
                              {item.value}
                            </h1>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : screenDetails?.screenType === "restaurant" ? (
                  <>
                    <div className="my-2">
                      <h1 className="text-gray-600 font-semibold text-base">
                        Restaurant Information
                      </h1>
                    </div>
                    <div className="ml-5 w-80">
                      {[
                        {
                          label: "Name",
                          value: screenDetails?.restaurant?.name,
                        },
                        {
                          label: "Location",
                          value: screenDetails?.restaurant?.location,
                        },
                        {
                          label: "Cuisine Type",
                          value: screenDetails?.restaurant?.cuisineType,
                        },
                        {
                          label: "Seating Capacity",
                          value: screenDetails?.restaurant?.seatingCapacity,
                        },
                        {
                          label: "Phone",
                          value:
                            screenDetails?.restaurant?.contactInformation
                              ?.phone,
                        },
                        {
                          label: "Email",
                          value:
                            screenDetails?.restaurant?.contactInformation
                              ?.email,
                        },
                      ].map((item, i) => (
                        <div key={i} className="my-1 grid grid-cols-12">
                          <div className="col-span-6">
                            <h1 className="text-gray-600 font-semibold text-base">
                              {item.label}
                            </h1>
                          </div>
                          <div className="col-span-6">
                            <h1 className="text-gray-400 font-medium text-base">
                              {item.value}
                            </h1>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        {/* Monthly Screen Count Section */}
        <div className="col-span-12 xl:col-span-6 lg:col-span-6">
          <div className="bg-white rounded-md p-5">
            <div className="bg-gray-100 rounded-md">
              <h1 className="text-gray-600 font-semibold text-center text-lg p-2 ml-3 mt-3 mb-3">
                Monthly Screen Count Days
              </h1>
              <div className="mt-2 mb-5">
                {monthlyScreenCount.length > 0 ? (
                  <table className="table-auto w-full">
                    <thead>
                      <tr>
                        <th className="px-4 py-2 text-left text-gray-600">
                          Month
                        </th>
                        <th className="px-4 py-2 text-left text-gray-600">
                          Days
                        </th>
                        <th className="px-4 py-2 text-left text-gray-600">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {monthlyScreenCount.map((count, index) => (
                        <tr key={index} className="border-t">
                          <td className="px-4 py-2 text-gray-800">
                            <span
                              onClick={() => {
                                setSelectedMonth(count.month);
                                setIsCampaignModalOpen(true);
                              }}
                              className="cursor-pointer"
                            >
                              {count.month}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-gray-600 text-lg">
                            {count.days}
                          </td>
                          <td className="px-4 py-2 flex space-x-3">
                            {/* Pay Button */}
                            <button
                              className={`px-3 py-1 rounded ${
                                paidStatus[count.month]
                                  ? "bg-green-500 text-white"
                                  : "bg-yellow-400 text-black"
                              }`}
                              onClick={() => handlePayClick(count)}
                              disabled={paidStatus[count.month]} // Disable if paid
                            >
                              {paidStatus[count.month] ? "Paid" : "Pay"}
                            </button>

                            {/* Download Invoice Button */}
                            {paidStatus[count.month] && (
                              <button
                                className="px-3 py-2 bg-blue-500 text-white rounded"
                                onClick={() =>
                                  handleDownloadInvoice(count.month)
                                }
                              >
                                View Invoice
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="text-gray-500 font-semibold ml-5 text-center">
                    No monthly screen count data available.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentDetailsModel
        isOpen={isModalOpen}
        onClose={closeModal}
        paymentData={paymentData} // Pass paymentData to modal
        onSubmit={handlePaymentSubmit} // Function to handle payment submission
      />

      {isCampaignModalOpen && selectedMonth && (
        <CampaignDetailsModal
          isOpen={isCampaignModalOpen}
          onClose={closeCampaignModal}
          MonthYear={selectedMonth}
          screenId={screenDetails?._id}
        />
      )}

      <div className="col-span-12 xl:col-span-7 lg:col-span-7 ">
        <div className="bg-white rounded-md p-5">
          <div className="bg-gray-100 rounded-md">
            <div className="p-5">
              {positionLogs?.length > 0 ? (
                <div className="mt-4">
                  <h1 className="text-gray-600 font-semibold text-base">
                    Position Logs
                  </h1>
                  <div className="mt-3 overflow-x-auto">
                    <table className="min-w-full border border-gray-300 bg-white rounded-md">
                      <thead>
                        <tr>
                          <th className="px-4 py-2 text-left text-gray-600 font-semibold">
                            Date
                          </th>
                          <th className="px-4 py-2 text-left text-gray-600 font-semibold">
                            Start Time
                          </th>
                          <th className="px-4 py-2 text-left text-gray-600 font-semibold">
                            End Time
                          </th>
                          <th className="px-4 py-2 text-left text-gray-600 font-semibold">
                            State
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {positionLogs.map((log, idx) => {
                          const currentDate = formatDate(log.start);
                          const showDate = currentDate !== lastDate;
                          lastDate = currentDate;
                          const stateColorClass =
                            log.state === "stopped"
                              ? "text-red-500"
                              : log.state === "moving"
                              ? "text-green-500"
                              : log.state === "app_off"
                              ? "text-yellow-500"
                              : "text-gray-700";

                          return (
                            <tr key={idx} className="border-t border-gray-300">
                              {showDate && (
                                <td
                                  rowSpan={
                                    positionLogs.filter(
                                      (l) => formatDate(l.start) === currentDate
                                    ).length
                                  }
                                  className="bg-gray-100 border-8 outline outline-1 outline-gray-300 text-center border-white text-gray-700"
                                >
                                  {currentDate}
                                </td>
                              )}
                              <td className="px-4 py-2 text-gray-700">
                                {new Date(log.start).toLocaleTimeString()}
                              </td>
                              <td className="px-4 py-2 text-gray-700">
                                {new Date(log.end).toLocaleTimeString()}
                              </td>
                              <td className={`px-4 py-2 ${stateColorClass}`}>
                                {log.state}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <p className="text-gray-500 font-semibold text-center">
                  No logs available for any state.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default ScreenDetails;
